import type { TreasuryPaymentsPrice } from '../../../__generated/treasury/types';
import { BattlePassRewardsAccess } from '../../../__generated/treasury/types';
import type { PaymentV2ProductBattlePassFragment } from '../_gql/fragments/__generated/payment-v2-product-battle-pass.fragment.gql.generated';
import type { ProductBattlePassI } from '../payment.types';

export const processBattlePassProduct = (
  rawProduct: PaymentV2ProductBattlePassFragment,
  battlePassRewardAccess: BattlePassRewardsAccess,
  isCreateSubscriptionAllowed: boolean,
  price: Pick<TreasuryPaymentsPrice, 'id' | 'basePrice'>
) => {
  const planBundleItem = isCreateSubscriptionAllowed ? rawProduct.bundles?.[0]?.plan : null;

  const product: ProductBattlePassI = {
    __typename: 'TreasuryProductBattlePass',
    id: rawProduct.id,
    name: rawProduct.name || '',
    description: rawProduct.description || '',
    price: {
      id: price.id,
      basePrice: {
        amount: price.basePrice.amount,
        currency: price.basePrice.currency,
      },
    },
    bundle: planBundleItem
      ? {
          name: planBundleItem.name,
          planId: planBundleItem.id,
          coupon: planBundleItem.appliedCoupon?.name || null,
          price: {
            amount: planBundleItem.basePrice.amount,
            currency: planBundleItem.basePrice.currency,
          },
          finalPrice: {
            amount: planBundleItem.finalPrice.amount,
            currency: planBundleItem.finalPrice.currency,
          },
        }
      : null,
    isAlreadyPaid: battlePassRewardAccess === BattlePassRewardsAccess.PAID,
  };
  return product;
};
